import styled from 'styled-components';
import { motion } from 'framer-motion';

// Heights for sticky positioning calculations
export const APP_HEADER_HEIGHT = 86; // HeaderV2 height (desktop)
export const HEADER_HEIGHT = 59; // Search bar height
export const THEAD_HEIGHT = 59; // Table column headers height
export const ROW_HEIGHT = 77;
export const BREADCRUMB_HEIGHT = 38;

export const Container = styled.div`
  width: 100%;

  > * {
    margin: 0;
    padding: 0;
  }
`;

// Sticky header rendered outside TreeTable for reliable sticky behavior
export const StickyHeader = styled.div<{ $stickyTop?: number }>`
  display: flex;
  align-items: center;
  width: 100%;
  height: ${HEADER_HEIGHT+1}px;
  background-color: ${({ theme }) => theme.colors.white};
  padding-left: 18px;
  position: sticky;
  top: ${({ $stickyTop }) => ($stickyTop ?? 0) + APP_HEADER_HEIGHT}px;
  z-index: 10;
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  border-radius: 6px 6px 0 0;

`;

export const TableContainer = styled.div<{ $stickyTop?: number }>`
  width: 100%;
  background-color: ${({ theme }) => theme.colors.white};
  border: 1px solid ${({ theme }) => theme.colors.stroke};
  border-top: none;
  border-radius: 0 0 6px 6px;

  .p-treetable {
    margin: 0;
    padding: 0;
    border-radius: 0 0 6px 6px;

    .p-treetable-wrapper {
      margin: 0;
      padding: 0;
      overflow: visible !important;
   
     
    }

    table {
      margin: 0;
      padding: 0;
    }

    .p-column-header-content {
      display: flex;
      align-items: center;
    

      .p-column-title {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }



    .p-treetable-thead {
      background-color: ${({ theme }) => theme.colors.white};
      position: sticky;
      top: ${({ $stickyTop }) => ($stickyTop ?? 0) + APP_HEADER_HEIGHT + HEADER_HEIGHT-1}px;
      z-index: 9;

      outline: 1px solid ${({ theme }) => theme.colors.stroke};
      /* height: ${THEAD_HEIGHT+2}px; */
      

      .c-name {
        width: 22%;
        position: relative;
      }
      .c-acc-type {
        width: 15%;
      }
    }

    .p-treetable-thead > tr > th {
      border: none;
      color: ${({ theme }) => theme.colors.prussianBlue};
      padding: 0 12px 0 10px;
      height: ${THEAD_HEIGHT}px;
      font-size: 18px;
      font-weight: 600;
      user-select: none;
      text-align: left;
      margin: 0;
     
    }
    .p-treetable-thead > tr > th:first-child {
      padding: 0 12px 0 21px;
     
    }

    .p-treetable-tbody > tr {
      color: ${({ theme }) => theme.colors.prussianBlue};
      border-bottom: 1px solid ${({ theme }) => theme.colors.stroke};
      background-color: ${({ theme }) => theme.colors.white};
      font-size: 14px;
      font-weight: 500;
      height: ${ROW_HEIGHT}px;

      &.expandable {
        cursor: pointer;
      }

      &.workspace-openable {
        cursor: pointer;
      }

      &.child-row-highlight {
        background-color: ${({ theme }) => theme.colors.childRowHighlight};

        &:hover {
          background: ${({ theme }) => theme.colors.cultured};
        }
      }

      &:hover {
        background: ${({ theme }) => theme.colors.cultured};
      }

      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;

      > td:first-child {
        padding: 0 12px 0 18px;
      }
      > td {
        padding: 0 12px 0 10px;
        white-space: nowrap;
        overflow: hidden;
      }

    

      /* Increase nested row indentation by 20px per level */
      &[aria-level='2'] > td:first-child {
        padding-left: 38px;
      }
      &[aria-level='3'] > td:first-child {
        padding-left: 58px;
      }
      &[aria-level='4'] > td:first-child {
        padding-left: 78px;
      }
      &[aria-level='5'] > td:first-child {
        padding-left: 98px;
      }
      &[aria-level='6'] > td:first-child {
        padding-left: 118px;
      }
      &[aria-level='7'] > td:first-child {
        padding-left: 138px;
      }
      &[aria-level='8'] > td:first-child {
        padding-left: 158px;
      }
      &[aria-level='9'] > td:first-child {
        padding-left: 178px;
      }
      &[aria-level='10'] > td:first-child {
        padding-left: 198px;
      }
    }

    .p-treetable-tbody > tr:last-child {
      border-bottom: none;
    }

    .p-treetable-tbody > tr:last-child > td:first-child {
      border-bottom-left-radius: 6px;
    }

    .p-treetable-tbody > tr:last-child > td:last-child {
      border-bottom-right-radius: 6px;
    }

    .p-treetable-toggler {
      width: 1.5rem;
      height: 1.5rem;
      margin-right: 0.5rem;
      color: ${({ theme }) => theme.colors.prussianBlue};
      position: relative;

      svg {
        opacity: 0;
        position: absolute;
        pointer-events: none;
      }

      &::before {
        content: '';
        display: block;
        width: 6px;
        height: 11px;
        background-color: currentColor;
        mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 11"><path d="M0 0.660586L0 9.88773C0 10.0664 0.0652145 10.2208 0.195535 10.3512C0.326 10.4817 0.480415 10.5469 0.658925 10.5469C0.837435 10.5469 0.991959 10.4817 1.12235 10.3512L5.73587 5.73764C5.86634 5.60703 5.93166 5.45262 5.93166 5.27414C5.93166 5.09567 5.86634 4.94111 5.73587 4.81075L1.12231 0.197161C0.991958 0.0668401 0.837434 0.00140949 0.658888 0.0014095C0.480414 0.00140951 0.325999 0.0668039 0.195498 0.197161C0.0650696 0.327518 0 0.482077 0 0.660586Z"/></svg>')
          no-repeat center;
        -webkit-mask: url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 6 11"><path d="M0 0.660586L0 9.88773C0 10.0664 0.0652145 10.2208 0.195535 10.3512C0.326 10.4817 0.480415 10.5469 0.658925 10.5469C0.837435 10.5469 0.991959 10.4817 1.12235 10.3512L5.73587 5.73764C5.86634 5.60703 5.93166 5.45262 5.93166 5.27414C5.93166 5.09567 5.86634 4.94111 5.73587 4.81075L1.12231 0.197161C0.991958 0.0668401 0.837434 0.00140949 0.658888 0.0014095C0.480414 0.00140951 0.325999 0.0668039 0.195498 0.197161C0.0650696 0.327518 0 0.482077 0 0.660586Z"/></svg>')
          no-repeat center;
        transition: transform 0.1s ease;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }

    tr[aria-expanded='false'] .p-treetable-toggler::before,
    tr:not([aria-expanded]) .p-treetable-toggler::before {
      transform: translate(-50%, -50%);
    }

    tr[aria-expanded='true'] .p-treetable-toggler::before {
      transform: translate(-50%, -50%) rotate(90deg);
    }
  }

  .c-hidden {
    display: none !important;
  }

  .c-tdm {
    width: 52px !important;
    position: relative;
  }

  .p-treetable-thead > tr > th.c-tdm {
    padding: 0 12px !important;
    text-align: center;

    .p-column-header-content {
      justify-content: center;
    }
  }

  .c-column-select {
    width: 60px !important;
    position: sticky !important;
    right: 0 !important;
    background-color: ${({ theme }) => theme.colors.white};
    z-index: 2;
  }

  .p-treetable-thead > tr > th.c-column-select {
    z-index: 4;
    padding: 0 16px 0 0 !important;
  }

  .p-treetable-tbody > tr > td.c-column-select {
    padding: 0 16px 0 0 !important;
  }

  .p-treetable-tbody > tr:hover > td.c-column-select {
    background-color: ${({ theme }) => theme.colors.cultured};
  }
`;

export const ColumnHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  min-width: 0;

  > span:first-child {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 0;
    flex: 1;
  }

  > div:last-child {
    flex-shrink: 0;
    margin-left: 8px;
  }
`;

export const StickyBreadcrumbSlot = styled.div`
  position: sticky;
  top: ${APP_HEADER_HEIGHT + HEADER_HEIGHT + THEAD_HEIGHT}px;
  z-index: 8;
  height: 0;
  width: 100%;
  min-width: 700px;
  overflow: visible;
  pointer-events: none;
`;

export const StickyBreadcrumb = styled(motion.div)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: ${BREADCRUMB_HEIGHT}px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  gap: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  border-left: 1px solid ${({ theme }) => theme.colors.stroke};
  border-right: 1px solid ${({ theme }) => theme.colors.stroke};
  border-bottom: 1px solid ${({ theme }) => theme.colors.stroke};
  box-shadow: 0 6px 18px ${({ theme }) => theme.colors.shadowLight};
  font-size: 12px;
  font-weight: 500;
  color: ${({ theme }) => theme.colors.cflowerBlue};
  overflow: hidden;
  white-space: nowrap;
  box-sizing: border-box;
  will-change: transform, opacity;
  pointer-events: auto;

  .breadcrumb-item {
    color: ${({ theme }) => theme.colors.prussianBlue};
    font-weight: 600;
  }

  .breadcrumb-separator {
    color: ${({ theme }) => theme.colors.cflowerBlue};
    flex-shrink: 0;
  }
`;
